// 빌드 env → 파이프라인 dropMode. 'tag' 외의 값은 전부 기본(drop)으로 떨어뜨려 오타가 "전량 전송" 으로 새지 않게 한다.
// 라이브 첫 주(D-19)만 tag 로 돌리고, 버리는 규칙을 검증한 뒤 CI env 한 줄로 drop 으로 되돌린다.

import type { DropMode } from './reporter'

export const resolveDropMode = (raw: string | undefined): DropMode =>
  raw === 'tag' ? 'tag' : 'drop'

// tag 모드에서 verdict=drop 을 보낼 비율. 범위 밖·빈 값은 1(전량)로 — 스테이징처럼 양을 재는 환경의 기본값.
export const resolveTagSampleRate = (raw: string | undefined): number => {
  const rate = Number(raw)
  if (raw === undefined || raw === '' || Number.isNaN(rate) || rate < 0 || rate > 1) return 1
  return rate
}
